.nudge-bubble {
    padding: 6px 8px;
    border-radius: 8px;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.wrapper {
    width: 100%;
}

@media (max-width: 1550px) {
    .wrapper [class*='leaderboard-secondary-value'] {
        display: none;
    }
}
